import { Dynamic } from "./dynamic.js";
import { EmbeddedTabStrip } from "./embeddedTabStrip.js";
import { General } from "../../../siteManagement/general.js";
import { Sheet } from "../../../siteManagement/sheet.js";
import { FAIcon } from "./faIcon.js";
import { ErrorBoundary } from "../../statistics/components/error_boundary.js";
import { Context, Entity } from "./commonApp.js";
import { CommandManagerAPI } from "../../commonInterfaces.js";
import { Helper } from "../util/helper.js";
import React from "react";
import ReactDOM from "react-dom";

export class RightDrawerContainer extends React.Component<RightDrawerProps, any>{
    private _rightDrawer: JQuery;
    private _sheet: Sheet;
    private _openedFirstTime = false;
    private _closedByUser: boolean = false;
    private _keyMapping: Array<string> = [];
    private _keyMappingRenderAlways: Array<string> = [];
    private _contentCleared = false;
    private _arrRenderAlways: any[] = [];
    private _arrIsRendered: boolean[] = [];

    constructor(props) {
        super(props);
        if (this.props.multipleComponents != null) {
            this._fillDefaultArrIsRendered();
        }
        this._setKeyMapping();
        this._sheet = General.Sheet.Manager.getTopMostVisibleSheet()
        this._rightDrawer = this._sheet.elements.getRightDrawerElementRef();

        General.Drawer.SideTabs.onToggle(this._onToggle);
    }

    private _fillDefaultArrIsRendered = () => {
        for (let i = 0; i < this.props.multipleComponents.length; i++) {
            this._arrIsRendered.push(false);
        }
    }

    private _onToggle = (isOpen: boolean) => {
        //nur wenn this._sheet === General.Sheet.Manager.getTopMostVisibleSheet() ?
        this._closedByUser = !isOpen;
        this.setState({});
    }

    private _getHeaderIconNamesRenderAlways = () => {
        return this._arrRenderAlways.map((props) => {
            return props["iconName"] as string;
        });
    }

    private _getHeaderIconNames = (multipleComponents: any[]) => {
        return multipleComponents.map((props) => {
            return props["iconName"] as string;
        });
    }

    private _getElements = () => {    
        if (this.props.entity.IsNew) {
            this._arrRenderAlways = [];
            if (this.props.multipleComponents != null) {
                for (let i = 0; i < this.props.multipleComponents.length; i++) {
                    if (this.props.multipleComponents[i].renderAlways) {
                        this._keyMappingRenderAlways.push(this._keyMapping[i]);
                        this._arrRenderAlways.push(this.props.multipleComponents[i]);
                    }
                } 
            } else if (this.props.renderAlways != null) {
                if (this.props.renderAlways) {
                    return <Dynamic {...this.props} />;;
                }             
            }
            
            if (this._arrRenderAlways.length > 0) {

                return (
                    <EmbeddedTabStrip headerIcons={this._getHeaderIconNamesRenderAlways()}>
                        {this._arrRenderAlways.map((props, index) => {
                            return <Dynamic key={this._keyMappingRenderAlways[index]} {...this.props} helpUrl={this.props.helpUrl } moduleName={props["moduleName"]} appName={props["appName"]} customProps={props["props"]} />
                        })}
                    </EmbeddedTabStrip>
                );
            } else {
                return this._getEmptyStateElement();
            }
        }
        else {
            if (this.props.multipleComponents instanceof Array) {
                let multipleComponents = this.props.multipleComponents.filter((props, index) => {                
                    let show = true;
                    if (props.show) {
                        show = Helper.hasValue(this.props.handleEval) ? this.props.handleEval(props.show) : eval(props.show);
                    }
                    return show;
                });
                
                if (multipleComponents.length > 0)
                {
                    let globIndex = this.props.multipleComponents.indexOf(multipleComponents[0]);
                    this._arrIsRendered[globIndex] = true;
                }
                
                return (
                    <EmbeddedTabStrip headerIcons={this._getHeaderIconNames(multipleComponents)} onTabSelected={(tabIndex: number) => {
                        let itemToFind = multipleComponents[tabIndex];
                        let globIndex = this.props.multipleComponents.findIndex((elem) => elem == itemToFind);
                        if (!this._arrIsRendered[globIndex]) {
                            this._arrIsRendered[globIndex] = true; this.setState({});
                        }
                    }}>
                        
                        {multipleComponents.map((props, index) => {
                            let globIndex = this.props.multipleComponents.findIndex((elem) => elem == props);
                            if (this._arrIsRendered[globIndex]) {
                                return <Dynamic key={this._keyMapping[globIndex]} {...this.props} helpUrl={this.props.helpUrl}  moduleName={props["moduleName"]} appName={props["appName"]} customProps={props["props"]} />
                            }
                            else {
                                return null;
                            }                      
                        })}
                    </EmbeddedTabStrip>
                );
            }
            return <Dynamic {...this.props} />;
        }
    }

    private _getEmptyStateElement = () => {
        return (
            <div style={{ display: "flex", alignItems: "center", fontSize: "14px", height: "100%", width: "100%", padding: "10px 5px", boxSizing: "border-box" }}>
                <div style={{ textAlign: "center", color: "#999" }}>
                    <FAIcon name="info" style={{ fontSize: "5em", marginBottom: "10px" }} />
                    <div style={{ lineHeight: "1.5em" }}>{Helper.getTranslation("Standard.EmptyState")}</div>
                </div>
            </div>
        );
    }

    private _setKeyMapping = () => {
        if (this.props.multipleComponents instanceof Array) {
            this.props.multipleComponents.map((props, index) => {
                this._keyMapping[index] = kendo.guid();
            });
        }
    }

    componentDidMount() {
        if (this.props.visible && this.props.moduleName !== null && !this.props.entity.IsNew) {
            this._openedFirstTime = true;
        }
    }

    componentDidUpdate(prevProps: RightDrawerProps) {
        if (!this._openedFirstTime && this.props.visible && this.props.moduleName !== null && !this.props.entity.IsNew) {
            this._openedFirstTime = true;
        }
        // Zirkuläre Referenzen wg. Context verhindern
        let replacerFunc = (name, val) => {
            if (name == "context")
                return undefined;
            else
                return val;
        };

        if (prevProps.multipleComponents instanceof Array && JSON.stringify(prevProps.multipleComponents, replacerFunc) !== JSON.stringify(this.props.multipleComponents, replacerFunc)) {
            this._setKeyMapping();
        }
    }

    shouldComponentUpdate() {
        return this.props.moduleName !== null || this.props.multipleComponents != null;
    }

    componentWillUnmount() {
        General.Drawer.SideTabs.deregisterToggle(this._onToggle);
    }

    render() {
        if (!General.Drawer.SideTabs.isOpen() || !this.props.visible || (this.props.moduleName === null && this.props.multipleComponents == null) || this._closedByUser) {
            return null;
        } else {
            return (
                <ErrorBoundary>
                    {ReactDOM.createPortal(this._getElements(), this._rightDrawer[0])}
                </ErrorBoundary>)
        }
    }
}

interface RightDrawerProps {
    moduleName: string;
    appName?: string;
    visible: boolean;
    width: number;
    customProps?: {};
    entity: Entity;
    allEntities?: any;
    context?: Context;
    commandManager?: CommandManagerAPI;
    handleEval?(expression: string);
    multipleComponents?: Array<any>;
    renderAlways?: boolean;
    helpUrl?: any;

}